module.exports = __webpack_public_path__ + "components/flag/static/square/ms-4109e0a071f614ae0e2af4af09f08008.svg";